import { Component, OnInit , Input} from '@angular/core';
import { SharingPanelService } from '../../shared-service/sharing-panel-service';
import { SharingPanelComponent } from '../../shared-components/sharing-panel/sharing-panel.component';
import { BaseService } from '../../shared-service/base.service';

@Component({
  selector: 'app-share-wall',
  templateUrl: './share-wall.component.html',
  styleUrls: ['./share-wall.component.css']
})
export class ShareWallComponent implements OnInit {

  @Input() sharingItem: any;

  shareActiveWall : boolean = false;

  constructor(private sps: SharingPanelService,public bs:BaseService) { }

  ngOnInit() {
    
    this.shareActiveWall = this.bs.getUserAttr("IsEnableActiveWall");
  }

  openPanel() {
    this.sps.updateComponentObj(SharingPanelComponent, this.sharingItem);
    this.sps.updateActiveWall(true);
}

}
